import { useEffect, useState } from "react";

const isValidProjectContent = (element) =>
  Boolean(
    element?.isConnected &&
      !element.classList.contains("skeleton-project-content") &&
      !element.closest(".skeleton-page")
  );

const findProjectContent = () => {
  const candidates = document.querySelectorAll("main .project-content");

  for (const candidate of candidates) {
    if (isValidProjectContent(candidate)) {
      return candidate;
    }
  }

  return null;
};

export function useProjectContent(enabled, resetKey = "") {
  const [element, setElement] = useState(null);

  useEffect(() => {
    if (!enabled) {
      setElement(null);
      return undefined;
    }

    setElement(null);

    const attach = () => {
      const content = findProjectContent();
      if (isValidProjectContent(content)) {
        setElement(content);
        return true;
      }
      return false;
    };

    attach();

    const observer = new MutationObserver(() => {
      attach();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, [enabled, resetKey]);

  return element;
}

export { findProjectContent, isValidProjectContent };
